import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import MediaUploadWithMeta from './MediaUploadWithMeta';
import useHomeSlides from '@/hooks/useHomeSlides';

export default function HomeManager() {
  const { slides, isLoading, saving, handleSlideChange, handleSave } = useHomeSlides();

  if (isLoading) return <p className="text-sm text-[#7a7a7a]">Caricamento contenuti...</p>;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Carosello Home</CardTitle>
        <p className="text-sm text-[#7a7a7a]">Scegli immagini o video, caricati oppure da YouTube, con i relativi metadati SEO.</p>
      </CardHeader>
      <CardContent className="space-y-6">
        {slides.map((slide, index) => {
          const type = slide.media_type || 'image';
          return <MediaUploadWithMeta
            key={slide.id || index}
            label={`Contenuto ${index + 1}`}
            fieldId={`home-slide-${index}`}
            type={type}
            url={type === 'video' ? slide.video_url || '' : slide.image || ''}
            meta={slide.image_meta || {}}
            onTypeChange={(media_type) => handleSlideChange(index, { media_type })}
            onChange={(url) => handleSlideChange(index, type === 'video' ? { video_url: url } : { image: url })}
            onMetaChange={(image_meta) => handleSlideChange(index, { image_meta })}
          />;
        })}
        <Button onClick={handleSave} disabled={saving || slides.length !== 3}>
          {saving ? 'Salvataggio...' : 'Salva modifiche'}
        </Button>
      </CardContent>
    </Card>
  );
}